var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28641",
    d: "M0 7l9-7 9 7v11H0z",
    fill: "#333230"
  })));
}
export default SvgLocationHome;